import { logger } from "..";

export function blockImageDrop(container: HTMLElement, name: string): void {
  container.addEventListener("drop", (e) => {
    const dataTransfer = e.dataTransfer;
    const files = dataTransfer?.files;
    const hasFiles = files && dataTransfer.files.length > 0;
    if (!hasFiles) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    logger.debug(`${name}: Image drop blocked`);
  });
}
